import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bbf06b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepDate" }
const _hoisted_2 = { class: "StepDate__title" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepDate__title" }, "Дата и период отправки", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-2 flex items-center" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-calendar mr-3" }, null, -1))
const _hoisted_11 = { class: "block" }
const _hoisted_12 = { class: "flex items-center ml-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-clock mr-3" }, null, -1))
const _hoisted_14 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.is_selected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Укажите дату и период отправки", 1),
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "mt-3",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_the_input, {
                  type: "date",
                  value: _ctx.state.date,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.date) = $event)),
                  min: _ctx.min_date,
                  max: _ctx.maxDate,
                  placeholder: "Дата отправки",
                  onChange: _ctx.onDateSelected
                }, null, 8, ["value", "min", "max", "onChange"]),
                _createVNode(_component_the_select, {
                  class: "mt-3",
                  disabled: !_ctx.state.date || !_ctx.state.is_period_check,
                  placeholder: "Период отправки",
                  value: _ctx.state.period_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.period_id) = $event)),
                  loading: _ctx.data_state.periods.is_loading,
                  failed: _ctx.data_state.periods.is_failed,
                  "error-text": "При получении списка периодов произошла ошибка",
                  searchable: false,
                  options: _ctx.getPeriods,
                  onChange: _ctx.onPeriodSelected,
                  onRefresh: _ctx.loadPeriods,
                  label: "title"
                }, null, 8, ["disabled", "value", "loading", "failed", "options", "onChange", "onRefresh"]),
                _createVNode(_component_checkbox, {
                  class: "mt-2",
                  label: "Выбрать период отправки",
                  value: _ctx.state.is_period_check,
                  "onUpdate:value": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.is_period_check) = $event)),
                    _ctx.onCheckboxChange
                  ]
                }, null, 8, ["value", "onUpdate:value"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_the_button, {
                    type: "submit",
                    disabled: !_ctx.state.date || !_ctx.state.period,
                    class: "primary text small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" Подтвердить ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 32))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.disabled,
              onClick: _ctx.emitReset
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.date)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.state.period.title), 1)
            ])
          ])
        ], 64))
  ]))
}